import * as Drag from "./Drag";
import * as Slide from "./Slide";
import { T } from '../../../Constants';
import * as ContextMenu from "./ContextMenu";

export const TemplatesOptions = { Slide, Drag, ContextMenu };
export const Templates: T.DiaTemplates[] = [Slide, Drag, ContextMenu];